import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {API_URL, QueryParam, Utils} from "lib-base";
import {Observable} from "rxjs";
import {InfoReferenciaPago, RequestDetallesFactura} from "../../shared/interfaces/liquidacion";

@Injectable({
  providedIn: 'root'
})
export class FacturaImpresaService {

  private baseUrl: string;

  constructor(@Inject(API_URL) public apiUrl: string, private http: HttpClient) {
    this.baseUrl = `${this.apiUrl}/api/facturas-impresas`;
  }

  getLoteFacturacionBySolicitud(solicitud: number): Observable<number> {
    const params: HttpParams = new HttpParams().set('solicitud', solicitud.toString());
    return this.http.get<number>(`${this.baseUrl}/lote-by-solicitud`, {params})
  }


  getDetalleFacturaByReferenceOrImpAndDoc(body: RequestDetallesFactura): Observable<InfoReferenciaPago> {
    const url = `${this.baseUrl}/public/detalle-factura-pago`;
    const params: QueryParam[] = [];
    if (body.referencia) params.push({key: 'referencia', value: body.referencia})
    if (body.lote) params.push({key: 'lote', value: body.lote})
    if (body.impuesto) params.push({key: 'impuesto', value: body.impuesto})

    return this.http.get<InfoReferenciaPago>(Utils.createQueryParams(url, params));
  }

}
